export default {
    toggle: "notifications.toggle",
    loaded: "notifications.loaded",
    new_notification: "notifications.new.notification",
    remove_notification: "notifications.new.notification.remove",
    toggle_notification: "notifications.new.notification.toggle",
    mark_as_read: "notifications.new.mark_as_read"
}